












import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "brand-provisioning-form": () =>
      import(
        "@/components/app/admin/settings/provisioning/brandProvisioningForm.vue"
      )
  }
})
export default class BrandProvisioningView extends Vue {
  public get pathBlueprintId() {
    return this.$_.get(this.$route, "query.pbpid");
  }
}
